import { useMemo } from "react";

import { useDomainTranslation } from "@/domain/_shared/i18n/use-domain-translation";
import { buildMunicipalPropertyCreateFormSchema } from "@/domain/municipal-property/models/build-municipal-property-create-form-schema";
import { MUNICIPAL_PROPERTY_MASTER_DATA_BOUNDS, resolveMaxCommissioningYear } from "@ark/shared";
export function useMunicipalPropertyFormSchema(): ReturnType<typeof buildMunicipalPropertyCreateFormSchema> {
  const { t }: ReturnType<typeof useDomainTranslation> = useDomainTranslation("municipal-property");
  const schema: ReturnType<typeof buildMunicipalPropertyCreateFormSchema> = useMemo((): ReturnType<
    typeof buildMunicipalPropertyCreateFormSchema
  > => {
    const maxCommissioningYear: number = resolveMaxCommissioningYear();
    return buildMunicipalPropertyCreateFormSchema({
      messages: {
        nameRequired: t("create.validation.nameRequired"),
        nameTooLong: t("create.validation.nameTooLong"),
        floorAreaPositive: t("create.validation.floorAreaPositive"),
        effectiveYearRange: t("create.validation.effectiveYearRange"),
        commissioningYearRange: t("create.validation.commissioningYearRange", {
          min: MUNICIPAL_PROPERTY_MASTER_DATA_BOUNDS.minCommissioningYear,
          max: maxCommissioningYear,
        }),
      },
      maxCommissioningYear,
    });
  }, [t]);
  return schema;
}
